import { render, staticRenderFns } from "./ColumnList.vue?vue&type=template&id=0b07beb0&scoped=true&"
import script from "./ColumnList.vue?vue&type=script&lang=js&"
export * from "./ColumnList.vue?vue&type=script&lang=js&"
import style0 from "./ColumnList.vue?vue&type=style&index=0&id=0b07beb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07beb0",
  null
  
)

export default component.exports